import { Routes } from '@angular/router';
import { APP_ROUTES_PATHS } from './app.routes.model';
import { authenticatedGuard } from './core/guards';
import { AUTH_ROUTES } from './auth/auth.routes';

export const APP_ROUTES: Routes = [
  ...AUTH_ROUTES,
  {
    path: APP_ROUTES_PATHS.EMPLOYEE,
    canMatch: [authenticatedGuard],
    loadChildren: () => import('./features/employee/employee.routes').then(m => m.EMPLOYEE_ROUTES),
  },
  {
    path: APP_ROUTES_PATHS.REGISTRATION,
    loadChildren: () =>
      import('./features/employee/registration/registration.routes').then(m => m.REGISTRATION_ROUTES),
  },
  {
    path: '**',
    redirectTo: APP_ROUTES_PATHS.EMPLOYEE,
  },
];
